import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ArchiveHero = () => {
  return (
    <section className="relative bg-gradient-to-br from-literary-navy via-primary to-academic-forest text-white overflow-hidden">
      <div className="absolute inset-0 bg-black/20"></div>
      <div className="absolute inset-0">
        <Image
            src = "/assets/images/tours_1.heic"
          alt="Talleres y Capacitaciones"
          className="w-full h-full object-cover opacity-30"
        />
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-32">
        <div className="max-w-4xl">
          
          <h1 className="font-headline text-4xl lg:text-6xl font-bold mb-6 leading-tight">
            Talleres y Capacitaciones
            <span className="block text-historical-gold">por Rosa María Cifuentes</span>
          </h1>
          
          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <div className="flex items-center space-x-3 text-gray-300">
              <Icon name="Clock" size={20} />
              <span className="font-body">Más de 100 capacitaciones</span>
            </div>
            <div className="flex items-center space-x-3 text-gray-300">
              <Icon name="FileText" size={20} />
              <span className="font-body">2,847 documentos</span>
            </div>
            <div className="flex items-center space-x-3 text-gray-300">
              <Icon name="Users" size={20} />
              <span className="font-body">Más de 10,000 inscritos</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ArchiveHero;